var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    [
      _c(
        "td",
        { staticClass: "boss-table-data", attrs: { "data-test": "job-id" } },
        [_vm._v("\n    " + _vm._s(_vm.job.displayId || "新規") + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass: "boss-table-data",
          attrs: { "data-test": "job-admin-name" },
        },
        [_vm._v("\n    " + _vm._s(_vm.job.adminName) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass: "boss-table-data left",
          attrs: { "data-test": "job-name" },
        },
        [_vm._v("\n    " + _vm._s(_vm.job.name) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass: "boss-table-data",
          attrs: { "data-test": "publish-plan" },
        },
        [_vm._v("\n    " + _vm._s(_vm.job.publishPlan) + "\n  ")]
      ),
      _vm._v(" "),
      _c("td", { staticClass: "boss-table-data" }, [
        _c("div", [
          _c(
            "button",
            {
              staticClass: "boss-button",
              attrs: { "data-test": "job-preview-button" },
              on: {
                click: function ($event) {
                  return _vm.windowOpenPreview("jobPrePublishedPreview")
                },
              },
            },
            [_vm._v("\n        求人\n      ")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pega-mt-05" }, [
          _c(
            "button",
            {
              staticClass: "boss-button pega-width-5-5rem",
              attrs: { "data-test": "job-search-preview-button" },
              on: {
                click: function ($event) {
                  return _vm.windowOpenPreview("jobSearchPrePublishedPreview")
                },
              },
            },
            [_vm._v("\n        検索一覧\n      ")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.isShowOptions
        ? [
            _c("job-pre-published-option-sell", {
              attrs: {
                rowspan: _vm.optionsRowspan,
                "photoclip-ids": _vm.photoclipIds,
                "interview-ids": _vm.interviewIds,
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }